/**
 * 配車計画 作業登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/driver_schedules/instructions`

const driver_schedule_instruction = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    edit ({ commit }, { driver_id, id }) {
      const api_path = `${API_PATH}/${id}/edit`
      const params = { driver_id: driver_id }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      const api_path = `${API_PATH}`
      return new Promise((resolve) => {
        Vue.$http.post(api_path, params).then( data => { 
          commit('snackbar/showInfo', { message: '登録しました'}, { root: true })
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.patch(api_path, params).then( data => {
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    destroy ({ commit }, { driver_id, id }) {
      const api_path = `${API_PATH}/${id}`
      const params = { driver_id: driver_id }
      return new Promise((resolve) => {
        Vue.$http.delete(api_path, { params: params }).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default driver_schedule_instruction
